import 'slick-carousel';
import $ from 'jquery';

import './app/modules/index.js';

import '../scss/shop.scss';
import './vin-search';
import {Helper} from './helper';
import {LocalStorage} from './local-storage';
import {Endpoints} from './endpoints';
import ZipAndCity from "./shop/form/zip-and-city_class";
import {canDisplayButton, changeDetection, createApplePaySession, fetchMerchantSession, processPaymentOnServer,log} from "./applePay";
import {ShopTrackingEvents} from "./shop/tracking/events";
import {ShopTracking} from "./shop/shopTracking";

$('.slick-slider').slick();

class ShopHandler {

    StorageKeyListingType = 'list-view';
    ClickHandlers = {};
    ChangeHandlers = {};


    HandleEvent = null;

    /**
     * @param  localStorage
     * @param helper
     * @param postcodeAndCity
     */
    constructor(
        localStorage,
        helper,
        zipAndCity
    ) {
        this.helper = helper;
        this.localStorage = localStorage;
        this.zipAndCity = zipAndCity;

        this.lockBasketAdd = true;
        this.addToCartButton = null;
        this.quantityBoxElement = null;

        this.setUpClickHandlers();
        this.setUpChangeHandlers();
    }

    setUpClickHandlers() {

        /**
         *
         *             'input[name="filter"]': el => {
         *                 const selectedValues = Array.from(el.closest('.product-listing-filter').querySelectorAll('input[name="filter"]'))
         *                     .filter(checkbox => checkbox.checked)
         *                     .map(checkbox => checkbox.value);
         *
         *                 window.location.href = this.getHelper().URLParameters(window.location.href, {filter: selectedValues});
         *             }
         */

        this.ClickHandlers = {
            '[data-filter-type-filter]': el => {
                if (el.closest('[data-reset]')) {
                    this.resetListingFilter(el, 'filter');
                    return;
                }
                this.handleListingFilter(el, 'filter');
            },
            '[data-filter-type-color]': el => {
                if (el.closest('[data-reset]')) {
                    this.resetListingFilter(el, 'color');
                    return;
                }
                this.handleListingFilter(el, 'color');
            },
            '[data-filter-type-size]': el => {
                if (el.closest('[data-reset]')) {
                    this.resetListingFilter(el, 'size');
                    return;
                }
                this.handleListingFilter(el, 'size');
            },
            '[data-discount-remove]': el => {
                this.removeDiscountVoucher('discount');
            },
            '[data-voucher-remove]': el => {
                this.removeDiscountVoucher();
            },
            '.product-listing-view': el => {
                if (el.closest('[data-selected]')) {
                    this.toggleProductListingView(el);
                    let standalone = el.closest('[data-standalone]');
                    if (standalone) {
                        let key = this.StorageKeyListingType + standalone.dataset.standalone;
                        this.getLocalStorage().set(key, el.dataset.listing);
                        return;
                    }
                    this.getLocalStorage().set(this.StorageKeyListingType, el.dataset.listing);
                }
            },
            '[data-watchlist]': el => {
                let dataWatchList = el.closest("[data-watchlist]");
                this.handleWishList(dataWatchList);
            },
            '[data-prod-request-trash]': el => {
                let dataProd = el.closest("[data-prod-request]");
                if (dataProd) {
                    this.removeProdFromBasketRequest(dataProd, el.closest(".product-line-item"));
                }
            },
            '[data-prod-request]': el => {
                if (el === el.closest("[data-prod-request-input]")) {
                    return;
                }

                this.preAddToBasket(el);

                let dataProd = el.closest("[data-prod-request]");
                if (dataProd) {
                    let vin = '';
                    if (dataProd.dataset.vin) {
                        vin = dataProd.dataset.vin;
                    }

                    this.addProdToBasketRequest({
                        product_id: dataProd.dataset.prodRequest,
                        product_quantity: null,
                        vin: vin
                    }, dataProd, el.closest("[data-prod-count]"));
                }
            },
            '[data-prod-trash]': el => {
                let dataProd = el.closest("[data-prod]");
                if (dataProd) {
                    this.removeProdFromBasket(dataProd, el.closest(".product-line-item"));
                }
            },
            '[data-prod]': el => {
                if (el === el.closest("[data-prod-input]")) {
                    return;
                }

                this.preAddToBasket(el);

                let dataProd = el.closest("[data-prod]");
                if (dataProd) {
                    let vin = '';
                    if (dataProd.dataset.vin) {
                        vin = dataProd.dataset.vin;
                    }

                    this.addProdToBasket({
                        product_id: dataProd.dataset.prod,
                        vin: vin,
                        product_quantity: null,
                    }, dataProd, el.closest("[data-prod-count]"));
                }
            },
            '[data-basket-flyout]': el => {
                if (el.closest("[data-flyout]")) {
                    return;
                }
                this.handleFlyout(el.closest("[data-basket-flyout]"));
            },
            '[data-available-sizes]': el => {
                const size = el.closest("[data-available-size]");

                if (size.dataset.hasOwnProperty('prodVariant')) {

                    let payload = { size: size.dataset.prodVariant };

                    let color = document.querySelector("[data-available-color].product-variant-attribute-selected")
                    if (color) {
                        payload.color = color.dataset.prodVariant;
                    }

                    window.location.href = this.getHelper().URLParameters(window.location.href, payload);

                }
            },
            '[data-available-colors]': el => {
                const color = el.closest("[data-available-color]");

                if (color.dataset.hasOwnProperty('prodVariant')) {

                    let payload = { color: color.dataset.prodVariant };
                    let size = document.querySelector("[data-available-size].product-variant-attribute-selected")
                    if (size) {
                        payload.size = size.dataset.prodVariant;
                    }

                    window.location.href = this.getHelper().URLParameters(window.location.href, payload);

                }

            },
            '[data-nav-root-link]': el => {
                this.handleMenuToggle(el);
            },
            '[data-apple-express-checkout]': el => {
                //window.handleApplePayExpress();
                this.handleApplePayExpress();
            },
            '[data-gallery]': el => {
                const image = el.closest('[data-gallery-image-container]');
                const galleryMain = document.querySelector('[data-gallery-main-image]');
                this.handleImageGallerySwap(galleryMain, image);
            },
            '.menu': el => {
                // nothing to do yet, but this prevents the body from firing this way, we won't close the menu when there is a click on the menu
            },
            'body': el => {
                this.closeAllMenuToggle();
            }
        };
    }

    resetListingFilter(el, name) {
        /*
                const checkboxes = el.querySelectorAll('input[type="checkbox"]');
                let canReset = false;
                // Loop through checkboxes and set checked property to false
                checkboxes.forEach((checkbox)=> {
                    if (checkbox.checked){
                        checkbox.checked = false;
                        canReset = true;
                    }
                });
        */

        if (name === 'filter') {
            window.location.href = this.getHelper().URLParameters(window.location.href, { filter: [] });
        }

        if (name === 'size') {
            window.location.href = this.getHelper().URLParameters(window.location.href, { size: [] });
        }

        if (name === 'color') {
            window.location.href = this.getHelper().URLParameters(window.location.href, { color: [] });
        }

    }

    handleListingFilter(el, name) {
        let selectedValues = Array.from(el.closest('.product-listing-filter').querySelectorAll(`input[name="${name}"]`))
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);

        if (selectedValues.length <= 0) {
            selectedValues = [];
        }

        if (name === 'size') {
            window.location.href = this.getHelper().URLParameters(window.location.href, { size: selectedValues });
        }

        if (name === 'color') {
            window.location.href = this.getHelper().URLParameters(window.location.href, { color: selectedValues });
        }

        if (name === 'filter') {
            window.location.href = this.getHelper().URLParameters(window.location.href, { filter: selectedValues });
        }

    }

    handleApplePayExpress() {
        if (canDisplayButton()) {
            let grossTotal = document.querySelector('[data-gross-total]');
            if (grossTotal?.dataset?.grossTotal > 0) {
                const Session = createApplePaySession(grossTotal.dataset.grossTotal, 'DE', 'EUR');

                Session.onvalidatemerchant = async event => {
                    log("handleApplePayExpress::onvalidatemerchant::event", event);
                    const merchantSession = await fetchMerchantSession();
                    log("handleApplePayExpress::onvalidatemerchant::merchantSession", merchantSession);
                    if (!merchantSession) {
                        console.error('Failed to fetch a valid merchant session');
                        return;
                    }

                    try {
                        Session.completeMerchantValidation(merchantSession);
                        log("handleApplePayExpress::SessionAfter::completeMerchantValidation", Session);
                    } catch (e) {
                        console.error('Error in merchant validation:', e);
                    }

                };

                Session.onpaymentauthorized = async (event) => {
                    log("handleApplePayExpress::onpaymentauthorized::event", event);
                    try {
                        const paymentResult = await processPaymentOnServer(event.payment);
                        log("handleApplePayExpress::onpaymentauthorized::paymentResult", paymentResult);
                        if (paymentResult.success == 1) {
                            log("handleApplePayExpress::onpaymentauthorized::paymentResult.success", paymentResult.success);
                            Session.completePayment({
                                "status": ApplePaySession.STATUS_SUCCESS,
                                "errors": [] // No errors
                            });
                            log("handleApplePayExpress::onpaymentauthorized::completePayment::Session", Session);
                            log("handleApplePayExpress::onpaymentauthorized::ApplePaySession", ApplePaySession.STATUS_SUCCESS);

                            //todo uncomment
                            //window.location.href = paymentResult.redirect;
                        } else {
                            log("handleApplePayExpress::onpaymentauthorized::ELSE::paymentResult", paymentResult);
                            Session.completePayment({
                                "status": ApplePaySession.STATUS_FAILURE,
                                "errors": paymentResult.errors // Assuming errors is an array of error messages
                            });
                        }
                    } catch (e) {
                        log("handleApplePayExpress::onpaymentauthorized::CATCH::Session", Session);
                        Session.completePayment({
                            "status": ApplePaySession.STATUS_FAILURE,
                            "errors": [new ApplePayError('unknown', 'unknown', 'An unexpected error occurred.')]
                        });
                    }
                };

                Session.oncancel = event => {
                    console.log('canceled ');
                    // Payment canceled by WebKit
                };
                Session.begin();
            }
        }
    }

    handleWishList(dataWatchList) {

        if (dataWatchList) {

            const watchListPage = document.querySelector('[data-watchlist-page]');

            let payload = { product_id: dataWatchList.dataset.watchlist };

            if (dataWatchList.classList.contains('active')) {

                if (watchListPage?.dataset.hasOwnProperty('watchlistPage')) {

                    const productCard = dataWatchList.closest('.product-card');
                    productCard?.remove();

                }

                dataWatchList.classList.remove('active');

                // Trigger the add to basket custom event
                ShopTrackingEvents.dispatchCustomEvent(
                    ShopTrackingEvents.CUSTOM_EVENT_REMOVE_FROM_WISHLIST,
                    {
                        [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_ID]: payload.product_id,
                        [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_QUANTITY]: payload.product_quantity,
                        [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PAYLOAD]: payload,
                        [ShopTrackingEvents.CUSTOM_EVENT_PARAM_ELEMENT_TO_START]: dataWatchList
                    }
                );

                this.helper.XHRAPI().Post(Endpoints.EndPointRemoveFromWatchList, JSON.stringify(payload), function(err, data) {
                    if (data) {
                        data = JSON.parse(data);
                        console.log(data);
                    } else {
                    }
                    if (err) {

                    }
                });

            } else {

                dataWatchList.classList.add('active');

                // Trigger the add to basket custom event
                ShopTrackingEvents.dispatchCustomEvent(
                    ShopTrackingEvents.CUSTOM_EVENT_ADD_TO_WISHLIST,
                    {
                        [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_ID]: payload.product_id,
                        [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_QUANTITY]: payload.product_quantity,
                        [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PAYLOAD]: payload,
                        [ShopTrackingEvents.CUSTOM_EVENT_PARAM_ELEMENT_TO_START]: dataWatchList
                    }
                );

                this.helper.XHRAPI().Post(Endpoints.EndPointAddToWatchList, JSON.stringify(payload), function(err, data) {
                    if (data) {
                        data = JSON.parse(data);
                        console.log(data);
                    } else {
                    }
                    if (err) {

                    }
                });

            }

        }

    }

    setUpChangeHandlers() {

        this.ChangeHandlers = {
            '#checkout_address_form_guest': el => {
                const formRegister = el.closest("#checkout_address_form_guest");
                this.registrationPasswordOnCheckCondition(formRegister);
            },
            '#checkout_address_form_shipping_address': el => {
                const deliveryAddress = el.closest("#checkout_address_form_shipping_address");
                this.differentDeliveryAddressOnCheckCondition(deliveryAddress);
            },
            'input[name="checkout_payment_form[shippingProvider]"]': el => {
                const select = el.closest('input[name="checkout_payment_form[shippingProvider]"]');

                let continueButton = document.querySelector('[data-continue-to-order]');
                if (continueButton) {
                    continueButton.classList.add('disabled')
                    continueButton.disabled = true;
                }

                ShopTrackingEvents.dispatchCustomEvent(
                    ShopTrackingEvents.CUSTOM_EVENT_ADD_SHIPPING_INFO,
                    {
                        shipping_type: select.value,
                        element: select
                    }
                );

                this.handleShippingProviderServices(select.value, () => {
                    this.reloadSummary();
                    this.reloadPage();
                });
            },
            'input[name="sorting"]': el => {
                const selectedValues = Array.from(el.closest('.product-listing-sort').querySelectorAll('input[name="sorting"]'))
                    .filter(checkbox => checkbox.checked)
                    .map(checkbox => checkbox.value);
                window.location.href = this.getHelper().URLParameters(window.location.href, { sortOrder: selectedValues.slice(0, 1).toString() });
            },
            'input[name="articleType"]': el => {
                const selectedValues = Array.from(el.closest('.product-listing-filter').querySelectorAll('input[name="articleType"]'))
                    .filter(checkbox => checkbox.checked)
                    .map(checkbox => checkbox.value);

                window.location.href = this.getHelper().URLParameters(window.location.href, { filter: selectedValues });
            },
            '[data-prod-request-input]': el => {
                let dataProd = el.closest("[data-prod-request]");

                this.preAddToBasket(el);

                if (dataProd) {
                    this.addProdToBasketRequest({
                        product_id: dataProd.dataset.prodRequest,
                        product_quantity: null,
                    }, dataProd);
                }
            },
            '[data-prod-input]': el => {
                let dataProd = el.closest("[data-prod]");

                this.preAddToBasket(el);

                if (dataProd) {
                    this.addProdToBasket({
                        product_id: dataProd.dataset.prod,
                        product_quantity: null,
                    }, dataProd);
                }
            }
        };

    }

    preAddToBasket(el) {
        this.addToCartButton = document.querySelector('[data-add-to-cart]');
        this.quantityBoxElement = el.closest('[data-quantity-box]');
    }

    handleShippingProviderServices(provider, onUpdateService = null) {

        const selectedPayments = document.querySelectorAll('input[name="checkout_payment_form[payment]"]');
        let selectedPayment = null;
        // Loop through the radio buttons to find the selected one
        for (let i = 0; i < selectedPayments.length; i++) {
            if (selectedPayments[i].checked) {
                selectedPayment = selectedPayments[i].value;
                break;
            }
        }

        const payload = {
            provider_id: provider,
            payment_type: selectedPayment
        };

        ShopTrackingEvents.dispatchCustomEvent(
            ShopTrackingEvents.CUSTOM_EVENT_ADD_SHIPPING_INFO,
            {
                provider_id: payload.provider_id,
                payment_type: payload.payment_type,
                payload: payload
            }
        );

        this.helper.XHRAPI().Post(Endpoints.EndPointShippingProviderServices, JSON.stringify(payload), (err, data) => {

            if (data && onUpdateService) {
                onUpdateService();
            } else {
            }
            if (err) {

            }
        });
    }

    handleMenuToggle(el) {

        this.HandleEvent.preventDefault();

        const navListRoot = el.closest("[data-nav-list-root]");
        const navListRootParent = el.closest("[data-nav-list-root]").parentElement;
        const childMenu = navListRoot?.querySelector('.children-sub');

        if (navListRoot) {
            navListRoot.classList.toggle('active');
        }

        if (navListRootParent) {
            const roots = navListRootParent.querySelectorAll("[data-nav-list-root]");
            roots.forEach(root => {

                if (root !== navListRoot) {
                    root.classList.remove('active');
                }
            });
        }
    }

    closeAllMenuToggle() {
        const roots = document.querySelector('body').querySelectorAll("[data-nav-list-root]");
        roots.forEach(root => {
            root.classList.remove('active');
        });

        const flyout = document.querySelector('body').querySelector("[data-flyout]");
        if (flyout && flyout?.classList.contains('d:none') === false) {
            flyout.classList.add('d:none');
        }
    }

    handleImageGallerySwap(galleryMain, imageDiv) {

        const image = imageDiv?.querySelector('img');

        if (image && galleryMain) {
            galleryMain.src = image.src;
            imageDiv.classList.add('product-variant-attribute-selected');
            const galleryImages = document.querySelectorAll(`[data-gallery-image-container]`);
            galleryImages.forEach((image) => {
                if (image !== imageDiv) {
                    image.classList.remove('product-variant-attribute-selected');
                }
            })
        }

    }

    handleFlyout(basket) {

        function getCartItemFrag(cart) {
            return `
<div class="fly-out-child-items d:flex flex-d:column flex-gap">

    <div class="d:flex flex-gap:small align-items:center">
        <div class="">
            <img data-flyout_image alt="${cart.prod_name}" src="${cart.prod_image}">
        </div>

        <div class="product-column-details">
            <div class="cart-item-details-container">
                <div class="product-item--name">
                    <a href="${cart.prod_link}" class="product-item-link" title="${cart.prod_name}">
                        ${cart.prod_name}
                    </a>
                </div>
                <div class="d:flex flex-d:column">
                    <span> Quantity: ${cart.prod_quantity}</span>
                    <span> Price: ${cart.prod_price}</span>
                </div>
            </div>
        </div>
    </div>

    <span class="border-bottom:default"></span>
</div>
`
        }

        const flyout = basket?.querySelector("[data-flyout]");
        const total = basket?.querySelector("[data-checkout-total]");
        const flyoutChildItems = basket?.querySelector(".fly-out-child-items");
        flyout.classList.toggle('d:none');

        let animation = basket.querySelector('.loading-animation');

        if (animation) {
            animation.classList.remove('d:none');
        }

        this.helper.XHRAPI().Get(Endpoints.EndPointBasketList, (err, data) => {
            if (data) {
                data = JSON.parse(data);
                animation.classList.add('d:none');
                if (data.hasOwnProperty('list')) {
                    flyoutChildItems.innerHTML = '';
                    data.list.forEach(it => {
                        flyoutChildItems.insertAdjacentHTML('beforeend', getCartItemFrag(it));
                    });
                }

                if (data.hasOwnProperty('total') && total) {
                    total.innerText = data.total;
                }
            } else {
            }
            if (err) {

            }
        });

    }

    addProdToBasketRequest(payload, dataProd, el = null) {

        let step = dataProd?.querySelector('input[type=number]');
        if (step) {
            if (el?.dataset.hasOwnProperty('prodCountDown')) {
                step.setAttribute('value', parseInt(step.getAttribute('value')) - 1);
            }

            if (el?.dataset.hasOwnProperty('prodCountUp')) {
                step.setAttribute('value', parseInt(step.getAttribute('value')) + 1);
            }
        }

        if ((this.quantityBoxElement && this.addToCartButton !== null) && this.lockBasketAdd) {
            return;
        }

        this.lockBasketAdd = false;
        payload.product_quantity = step?.value;

        let qtyBox = document.querySelector('[data-quantity-box]');
        if (qtyBox && this.addToCartButton) {
            step = qtyBox.querySelector('input[type=number]');
            payload.product_quantity = step.value;
        }

        // Trigger the add to basket custom event
        ShopTrackingEvents.dispatchCustomEvent(
            ShopTrackingEvents.CUSTOM_EVENT_ADD_TO_REQUEST_CART,
            {
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_ID]: payload.product_id,
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PAYLOAD]: payload.product_quantity,
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_QUANTITY]: payload,
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_ELEMENT_TO_START]: dataProd
            }
        );

        this.helper.XHRAPI().Post(Endpoints.EndPointAddToBasketRequest, JSON.stringify(payload), (err, data) => {
            if (data) {
                data = JSON.parse(data);
                this.reloadCartRequestItemCount();
                console.log(data);
            } else {
            }
            if (err) {

            }
        });
    }

    removeProdFromBasketRequest(dataProd, prodLineItem) {
        let payload = { product_id: dataProd.dataset.prodRequest }

        this.helper.XHRAPI().Post(Endpoints.EndPointRemoveFromBasketRequest, JSON.stringify(payload), (err, data) => {
            if (data) {
                data = JSON.parse(data);
                prodLineItem?.remove();
                this.reloadCartRequestItemCount();
                console.log(data);
            } else {
            }
            if (err) {

            }
        });
    }

    addProdToBasket(payload, dataProd, el = null) {
        let qtyBox = null;
        let parentContainer = $(dataProd).parents('[data-vin-product-container]');
        if (parentContainer) {
            qtyBox = parentContainer.find('[data-quantity-box]').get(0);
        } else {
            qtyBox = dataProd.closest('[data-quantity-box]');
        }

        if (!qtyBox) {
            qtyBox = document.querySelector('[data-quantity-box]');
        }

        let stepQtyBox = qtyBox?.querySelector('input[type=number]').value;
        let step = dataProd?.querySelector('input[type=number]');

        if (qtyBox?.querySelector('input[type=number]').dataset.hasOwnProperty('prodIncrement')) {
            payload.quantity_increment = true;
        }

        if (step) {
            if (el?.dataset.hasOwnProperty('prodCountDown')) {
                step.stepDown();

                if (step.value == 1 && stepQtyBox == 1) {
                    return;
                }

                payload.step_down = true;
            }

            if (el?.dataset.hasOwnProperty('prodCountUp')) {
                step.stepUp();
                payload.step_up = true;
            }
        }

        if ((this.quantityBoxElement && this.addToCartButton !== null) && this.lockBasketAdd) {
            return;
        }

        this.lockBasketAdd = false;
        payload.product_quantity = step?.value;

        if (qtyBox && this.addToCartButton) {

            step = qtyBox.querySelector('input[type=number]');
            const maxAttributeValue = step.max;

            // Check if the max attribute is specified
            if (maxAttributeValue !== '') {
                // Ensure that the value is not greater than the max attribute
                if (parseFloat(step.value) > parseFloat(maxAttributeValue)) {
                    step.value = maxAttributeValue; // Set the value to the max if it exceeds the limit
                }
            }

            payload.product_quantity = step.value;

            this.lockBasketAdd = true;
            this.addToCartButton = null;

        }

        // Trigger the add to basket custom event
        ShopTrackingEvents.dispatchCustomEvent(
            ShopTrackingEvents.CUSTOM_EVENT_ADD_TO_CART,
            {
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_ID]: payload.product_id,
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_QUANTITY]: payload.product_quantity,
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PAYLOAD]: payload,
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_ELEMENT_TO_START]: dataProd
            }
        );

        this.helper.XHRAPI().Post(Endpoints.EndPointAddToBasket, JSON.stringify(payload), (err, data) => {
            if (data) {
                data = JSON.parse(data);
                this.reloadSummary();
                this.reloadCartItemCount();
                console.log(data);
            } else {
            }
            if (err) {

            }
        });
    }

    removeProdFromBasket(dataProd, prodLineItem) {
        let payload = { product_id: dataProd.dataset.prod }

        // Get the closest tracking data
        const trackingData = ShopTracking.getClosestTrackingData(
            prodLineItem,
            ShopTracking.DATA_ATTRIBUTE_TRACKING_PRODUCT
        )

        // Trigger the add to basket custom event
        ShopTrackingEvents.dispatchCustomEvent(
            ShopTrackingEvents.CUSTOM_EVENT_REMOVE_FROM_CART,
            {
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_ID]: payload.product_id,
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_PRODUCT_QUANTITY]: payload.product_quantity,
                [ShopTrackingEvents.CUSTOM_EVENT_PARMETER_TRACKING_DATA]: trackingData,
                [ShopTrackingEvents.CUSTOM_EVENT_PARAM_ELEMENT_TO_START]: dataProd
            }
        );

        this.helper.XHRAPI().Post(Endpoints.EndPointRemoveFromBasket, JSON.stringify(payload), (err, data) => {
            if (data) {
                data = JSON.parse(data);
                prodLineItem?.remove();
                this.reloadSummary();
                this.reloadCartItemCount();
            } else {
            }
            if (err) {

            }
        });
    }

    removeDiscountVoucher(type = 'voucher') {

        let payload = { voucher: true };

        if (type === 'discount') {
            payload = { discount: true };
        }

        this.helper.XHRAPI().Post(Endpoints.EndPointBasketRemoveDiscountVoucher, JSON.stringify(payload), (err, data) => {
            if (data) {
                this.reloadSummary();
            } else {
            }
            if (err) {

            }
        });

    }

    reloadSummary() {

        const checkoutAside = document.querySelector('.checkout-aside-summary-list-container');

        if (checkoutAside) {

            this.helper.XHRAPI().Get(Endpoints.EndPointBasketSummary + '/' + document.documentElement.lang, (err, data) => {

                if (data) {
                    data = JSON.parse(data);
                    if (data?.hasOwnProperty('summary') && checkoutAside) {

                        checkoutAside.innerHTML = data.summary;

                        let reload = true;
                        let isValidCart = document.querySelector('[data-is_valid_cart]');
                        let isCartEmpty = document.querySelector('[data-cart_is_empty]');
                        if (isValidCart) {
                            reload = false;
                        }

                        if (isCartEmpty) {
                            this.reloadPage();
                            return;
                        }


                        if (reload) {

                            if (isValidCart) {
                                let checkoutBTN = document.querySelector('.begin-checkout-button');
                                if (checkoutBTN) {
                                    this.reloadPage();
                                }
                            }

                        }


                    }

                } else {
                }
                if (err) {

                }
            });

        }

        return this;
    }

    toggleProductListingView(el, done = null) {
        const selectedElements = el.closest('.product-listing-view').querySelectorAll('[data-selected]');
        const productListing = document.querySelector('.product-listing');


        selectedElements.forEach(element => {

            element.classList.remove('active');
            element.dataset.selected = 'false';

            if (element === el) {
                element.classList.add('active');
                element.dataset.selected = 'true';

                setTimeout(() => {

                    if (productListing) {
                        if (element.dataset.listing === 'listing-view') {
                            productListing.classList.add('listing-view');
                            productListing.classList.remove('tiles-view');
                        } else if (element.dataset.listing === 'tiles-view') {
                            productListing.classList.add('tiles-view');
                            productListing.classList.remove('listing-view');
                        }
                    }

                }, 650);
            }
        });
    }

    productListingViewOnLoad() {

        let standalone = document.querySelector('[data-standalone]');
        let key = this.StorageKeyListingType;

        if (standalone) {
            key = key + standalone.dataset.standalone;
        }

        if (this.getLocalStorage().has(key)) {
            const listingType = '[data-listing="' + this.getLocalStorage().get(this.StorageKeyListingType) + '"]';
            const el = document.querySelector(`${listingType}`);
            const handler = this.getClickHandler('.product-listing-view');
            if (el && handler) {
                handler(el);
            }
        }

        return this;
    }

    registrationPasswordOnCheckCondition(formRegisterCheck) {

        if (formRegisterCheck) {

            let showPasswordFields = true;
            if (formRegisterCheck?.checked) {
                showPasswordFields = false;
            }

            const passwordField = document.getElementById('checkout_address_form_password_first');
            const repeatPasswordField = document.getElementById('checkout_address_form_password_second');

            if (passwordField && repeatPasswordField) {
                if (showPasswordFields) {
                    passwordField?.setAttribute('required', 'required');
                    repeatPasswordField?.setAttribute('required', 'required');
                    passwordField?.removeAttribute('disabled');
                    repeatPasswordField?.removeAttribute('disabled');
                    passwordField.style.display = 'flex';
                    repeatPasswordField.style.display = 'flex';

                    const passwordFieldRow = passwordField.closest('.form-row');
                    if (passwordFieldRow) {
                        passwordFieldRow.style.display = 'flex';
                    }

                } else {
                    passwordField.removeAttribute('required');
                    repeatPasswordField.removeAttribute('required');
                    passwordField.value = '';
                    repeatPasswordField.value = '';
                    passwordField.setAttribute('disabled', 'disabled');
                    repeatPasswordField.setAttribute('disabled', 'disabled');
                    passwordField.style.display = 'none';
                    repeatPasswordField.style.display = 'none';

                    const passwordFieldRow = passwordField.closest('.form-row');
                    if (passwordFieldRow) {
                        passwordFieldRow.style.display = 'none';
                    }
                }
            }

        }

        return this;
    }

    differentDeliveryAddressOnCheckCondition(diffDeliverCheck) {

        if (diffDeliverCheck) {

            let show = false;
            let addressForm = document.getElementsByName('checkout_address_form');
            let toggleCountryMessage = addressForm[0].querySelector('.form-row.no-country-message');
            if (diffDeliverCheck?.checked) {
                show = true;
                if (toggleCountryMessage) {
                    toggleCountryMessage.style.display = 'none';
                }
            } else {
                if (toggleCountryMessage) {
                    toggleCountryMessage.style.display = 'block';
                }
            }

            let parentEl = document.querySelector('[data-additional-delivery-address]');

            if (show) {
                this.toggleRequiredFields(parentEl, false);
                parentEl.style.display = 'block';
            } else {
                this.toggleRequiredFields(parentEl, true);
                parentEl.style.display = 'none';
            }

        }

        return this;

    }

    toggleRequiredFields(parentElement, removeRequired = true) {

        const inputElements = parentElement.querySelectorAll('input, select, checkbox');
        for (let i = 0; i < inputElements.length; i++) {
            if (removeRequired) {
                inputElements[i].removeAttribute('required');
            } else {
                if (inputElements[i].parentElement.classList.contains('selectize-input')) {
                    continue;
                }
                if (inputElements[i].tagName.toLowerCase() !== 'select') {
                    inputElements[i].setAttribute('required', '');
                }
            }
        }
    }

    reloadCartItemCount() {

        this.helper.XHRAPI().Get(Endpoints.EndPointBasketItemCount, (err, data) => {

            if (data) {
                data = JSON.parse(data);
            }

            const dataCartItemCount = document.querySelectorAll('[data-cart-item-count]');
            if (dataCartItemCount && data.hasOwnProperty('count')) {
                dataCartItemCount.forEach((cartItem) => {
                    cartItem.innerHTML = data.count;
                })
            }

        });

    }

    reloadCartRequestItemCount() {

        this.helper.XHRAPI().Get(Endpoints.EndPointBasketRequestItemCount, (err, data) => {

            if (data) {
                data = JSON.parse(data);

                const { count } = data;

                if (count === 0) {
                    this.reloadPage();
                    return;
                }
            }

            const dataCartItemCount = document.querySelectorAll('[data-cart-request-item-count]');
            if (dataCartItemCount && data.hasOwnProperty('count')) {
                dataCartItemCount.forEach((cartItem) => {
                    cartItem.innerHTML = data.count;
                })
            }

        });
    }

    reloadPage() {
        location.reload();
    }

    /**
     * @returns LocalStorage
     */
    getLocalStorage() {
        return this.localStorage;
    }

    /**
     * @returns Helper
     */
    getHelper() {
        return this.helper;
    }

    getClickHandler(handler) {
        if (this.ClickHandlers.hasOwnProperty(handler)) {
            return this.ClickHandlers[handler];
        }
        return null;
    }

    getClickHandlers() {
        return this.ClickHandlers;
    }

    handleClickEvent(el) {
        for (const selector in this.ClickHandlers) {
            if (el.closest(selector)) {
                this.ClickHandlers[selector](el);
                break;
            }
        }
    }

    handleChangeEvent(el) {
        for (const selector in this.ChangeHandlers) {
            if (el.closest(selector)) {
                this.ChangeHandlers[selector](el);
                break;
            }
        }
    }

    handleOnLoad() {
        this.productListingViewOnLoad()
            .registrationPasswordOnCheckCondition(document.getElementById('checkout_address_form_guest'))
            .differentDeliveryAddressOnCheckCondition(document.getElementById('checkout_address_form_shipping_address'));
    }


}

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        // This function will be executed after all DOM content has loaded
        const shopHandler = new ShopHandler(
            new LocalStorage(),
            new Helper(),
            new ZipAndCity(
                new LocalStorage(),
                new Helper(),
            )
        );
        shopHandler.handleOnLoad();

        // Bind a click event listener to the body using event delegation
        const bodyElement = document.querySelector('body');
        bodyElement.addEventListener('click', e => {
            const el = e.target;
            shopHandler.HandleEvent = e;
            shopHandler.handleClickEvent(el);
        });

        bodyElement.addEventListener('change', e => {
            const el = e.target;
            shopHandler.HandleEvent = e;
            shopHandler.handleChangeEvent(el);
        });
    }
}

